import React, { useEffect, useRef, useState } from 'react';
import { Editor } from 'primereact/editor';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { MergeTagServ } from '../services/api/MergeTagServ';
import { FooterServ } from '../services/api/FooterServ';
import './MarkupChanger.css';

const MarkupChanger = ({
  open,
  text,
  handleCloseEditor,
  isWebinarEnabled,
  webinarTitleVal,
  durationVal,
  webinarTypeBC,
  liveWebinarTitleBC,
  speakersFlagBC,
  currentEditSection
}) => {

  const [isWebinar, setIsWebinar] = useState(isWebinarEnabled);
  const [webinarType, setWebinarType] = useState(webinarTypeBC);
  const [webinarTitle, setTitle] = useState(webinarTitleVal);
  const [duration, setDuration] = useState(durationVal);

  const [visible, setVisible] = useState(open || false);

  // CHANGED: replaced useState with useRef to avoid re-render conflicts with Quill
  const markupRef = useRef(text || "");

  const [liveWebinarTitle, setLiveWebinarTitle] = useState(liveWebinarTitleBC);
  const [speakersFlag, setSpeakersFlag] = useState(speakersFlagBC);

  // FOOTERS
  const [savedFooters, setSavedFooters] = useState([]);
  const [selectedFooter, setSelectedFooter] = useState(null);

  // MERGE TAGS
  const [mergeTags, setMergeTags] = useState([]);

  const [showTagDialog, setShowTagDialog] = useState(false);
  const [tagInput, setTagInput] = useState("");

  const editorRef = useRef(null);

  // GET FOOTERS
  const getFooters = async () => {
    try {
      const res = await FooterServ.index();
      setSavedFooters(
        res?.data?.data ||
        res?.data ||
        []
      );
    } catch (error) {
      console.log(error);
    }
  };

  // GET MERGE TAGS
  const getMergeTags = async () => {
    try {
      const res = await MergeTagServ.index();
      setMergeTags(
        res?.data?.data ||
        res?.data ||
        []
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getFooters();
    getMergeTags();
  }, []);

  // CHANGED: now writes to markupRef and drives Quill directly, no setState
  useEffect(() => {

    console.log("Received text prop:", text);

    if (text !== undefined && text !== null) {

      setTimeout(() => {

        markupRef.current = text;

        const quill = editorRef.current?.getQuill();

        if (quill) {
          quill.root.innerHTML = text;
        }

      }, 100);

    } else {

      markupRef.current = "";

      const quill = editorRef.current?.getQuill();

      if (quill) {
        quill.root.innerHTML = "";
      }
    }

  }, [text, visible]);

  const isWebinarStatus = (event) => {
    setIsWebinar(event.target.checked);
  }

  const handleDuration = (event) => {
    setDuration(event.target.value);
  }

  const handleTitle = (event) => {
    setTitle(event.target.value);
  }

  // CLEAN EMPTY HTML TAGS
  const cleanEditorHtml = (html) => {
    if (!html) return "";
    let cleaned = html;
    cleaned = cleaned.replace(/<p><br><\/p>/gi, '');
    cleaned = cleaned.replace(/<div><br><\/div>/gi, '');
    cleaned = cleaned.replace(/<(\w+)(\s[^>]*)?>(\s|&nbsp;)*<\/\1>/gi, '');
    return cleaned.trim();
  };

  // CHANGED: reads from markupRef instead of markup state
  const handleSubmit = () => {

    const cleanedMarkup = cleanEditorHtml(markupRef.current);

    handleCloseEditor(
      cleanedMarkup,
      isWebinar,
      duration,
      webinarTitle,
      webinarType,
      liveWebinarTitle,
      speakersFlag,
      selectedFooter?.content || ""
    );

    setVisible(false);
  };

  // CHANGED: reads from markupRef instead of markup state
  const handleClose = () => {

    const cleanedMarkup = cleanEditorHtml(markupRef.current);

    handleCloseEditor(
      cleanedMarkup,
      isWebinar,
      duration,
      webinarTitle,
      webinarType,
      liveWebinarTitle,
      speakersFlag,
      selectedFooter?.content || ""
    );
    // console.log(liveWebinarTitle);
    setVisible(false);
  };

  // ADD MULTIPLE TAGS
  const handleAddTags = async () => {

    if (!tagInput.trim()) return;

    try {

      const splitTags = tagInput
        .split(/[,;]+/)
        .map((tag) => tag.trim())
        .filter(Boolean);

      const res = await MergeTagServ.create({
        tags: splitTags,
      });

      setMergeTags((prev) => [
        ...prev,
        ...(res?.data?.data || [])
      ]);

      setTagInput("");

      setShowTagDialog(false);

    } catch (error) {
      console.log(error);
    }
  };

  // CHANGED: removed delayed setMarkup, Quill manages its own DOM
  const insertMergeTag = (tag) => {

    if (!tag || typeof tag !== "string") return;

    const quill = editorRef.current?.getQuill();

    if (!quill) return;

    quill.focus();

    let range = quill.getSelection();

    if (!range) {
      range = { index: quill.getLength() - 1, length: 0 };
    }

    quill.insertText(range.index, tag, "user");

    quill.setSelection(range.index + tag.length, 0);
  };

  // FOOTER SELECT
  const handleFooterSelect = (footer) => {
    setSelectedFooter(footer);
  };

  // CUSTOM TOOLBAR
  const renderHeader = () => {

    return (
      <span className="ql-formats flex align-items-center gap-2">

        <select className="ql-header" defaultValue="">
          <option value="1"></option>
          <option value="2"></option>
          <option value=""></option>
        </select>

        <button className="ql-bold"></button>

        <button className="ql-italic"></button>

        <button className="ql-underline"></button>

        <button className="ql-link"></button>

       {/* Bullet List */}
  <button className="ql-list" value="bullet"></button>

  {/* Numbered List */}
  <button className="ql-list" value="ordered"></button>
        {/* MERGE TAGS */}
       <Dropdown
  className="merge-tag-dd p-dropdown"
  options={mergeTags}
  optionLabel="label"
  placeholder="Merge Tags"
  style={{ width: "12rem" }}
  value={null}
  filter
  filterPlaceholder="Search tags"
  onShow={getMergeTags}
  onChange={(e) => {
    const selectedTag =
      typeof e.value === "string"
        ? e.value
        : e.value?.value;

    insertMergeTag(selectedTag || "");
  }}
/>

        {/* ADD TAGS */}
        <Button
          type="button"
          icon="pi pi-plus"
          className="p-button-text"
          onClick={() => setShowTagDialog(true)}
        />

      </span>
    );
  };

  const headerContent = (
    <div className='flex justify-content-end'>
      <Button
        label="Update"
        icon="pi pi-check"
        onClick={() => handleSubmit()}
        autoFocus
      />
    </div>
  );

  return (
    <>
      <Dialog
        header="Markup Editor"
        footer={headerContent}
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => handleClose()}
      >

        <form>

          <div className="card">

            {/* CHANGED: removed value={markup}, added onTextChange to write to markupRef */}
            <Editor
              ref={editorRef}
              onLoad={() => {
                const quill = editorRef.current?.getQuill();
                if (quill && text) {
                  quill.root.innerHTML = text;
                }
              }}
              onTextChange={(e) => {
                markupRef.current = e.htmlValue || "";
              }}
              headerTemplate={renderHeader()}
              style={{ height: "200px" }}
            />

          </div>

          {/* FOOTER DROPDOWN */}
          {currentEditSection === 'FOOTER_CONTENT' && (

            <div className="flex" style={{ marginTop: "20px" }}>

              <div className="col-6 flex align-items-center">
                Select Footer:
              </div>

              <div className="col-6">
                <Dropdown
                  value={selectedFooter}
                  options={savedFooters}
                  optionLabel="name"
                  placeholder="Select Footer"
                  onChange={(e) => handleFooterSelect(e.value)}
                  style={{ width: "14rem" }}
                />
              </div>

            </div>
          )}

          <div style={{ marginTop: "20px" }}>

            <label htmlFor="name">
              Is it a Webinar ?
            </label>

            <input
              type="checkbox"
              style={{
                width: "25px",
                height: "25px",
                position: "relative",
                top: "7px",
                marginLeft: "20px",
              }}
              id="isWebinar"
              name="isWebinar"
              checked={isWebinar || false}
              onChange={isWebinarStatus}
            />

            <br />

          </div>

          {(isWebinar &&
            localStorage.getItem('template_name') !==
            "Demand7-Becker's Campaign") && (

            <div className="grid">

              <div className={`col-6`} style={{ marginTop: "20px" }}>

                <label htmlFor="email">Webinar Title :</label>

                <br />

                <input
                  style={{
                    padding: "15px",
                    borderRadius: "12px",
                    marginTop: "10px",
                    borderColor: "#00000029",
                  }}
                  type="text"
                  id="webinarTitle"
                  name="webinarTitle"
                  value={webinarTitle}
                  onChange={handleTitle}
                />

              </div>

              <div className={`col-6`} style={{ marginTop: "20px" }}>

                <label htmlFor="email">Duration:</label>

                <br />

                <input
                  style={{
                    padding: "15px",
                    borderRadius: "12px",
                    marginTop: "10px",
                    borderColor: "#00000029",
                  }}
                  type="text"
                  id="duration"
                  name="duration"
                  value={duration}
                  onChange={handleDuration}
                />

                <br />

              </div>

            </div>
          )}
 {(isWebinar &&
            localStorage.getItem('template_name') ===
            "Demand7-Becker's Campaign") && (
          <div className="grid">

  {/* Speakers Checkbox */}
  <div className="col-12" style={{ marginTop: "15px" }}>
    <label htmlFor="speakersFlag">
      Does It Contain Speakers ?
    </label>

    <input
      type="checkbox"
      style={{
        width: "20px",
        height: "20px",
        position: "relative",
        top: "5px",
        marginLeft: "20px",
      }}
      id="speakersFlag"
      checked={speakersFlag || false}
      onChange={(e) => setSpeakersFlag(e.target.checked)}
    />
  </div>

  {/* Webinar Type Dropdown */}
  <div className="col-6" style={{ marginTop: "20px" }}>

    <label>Webinar Type:</label>

    <Dropdown
      value={webinarType}
      options={[
        { label: "Live Webinar", value: "liveWebinar" },
        { label: "On Demand", value: "onDemand" },
       
      ]}
      onChange={(e) => setWebinarType(e.value)}
      placeholder="Select Webinar Type"
      style={{ width: "100%", marginTop: "10px" }}
    />

  </div>

  {/* Live Webinar Title / Date */}
  <div className="col-12" style={{ marginTop: "20px" }}>

    <label>Date & Time Details</label>

    <InputText
      value={liveWebinarTitle || ""}
      onChange={(e) => setLiveWebinarTitle(e.target.value)}
      placeholder="Enter webinar date & time"
      style={{
        width: "100%",
        marginTop: "10px",
        padding: "12px",
      }}
    />

  </div>

</div>
  )}
        </form>

      </Dialog>

      {/* ADD TAGS POPUP */}
      <Dialog
        header="Add Merge Tags"
        visible={showTagDialog}
        style={{ width: "35rem" }}
        onHide={() => setShowTagDialog(false)}
      >

        <div className="flex flex-column gap-4">

          <div className="flex flex-column gap-2">

            <label>Enter single or multiple tags</label>

            <InputText
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              placeholder="example: first_name, email; company_name"
            />

            <small className="text-500">
              Separate multiple tags using comma or semicolon
            </small>

          </div>

          <div className="flex justify-content-end gap-2">

            <Button
              label="Cancel"
              className="p-button-outlined"
              onClick={() => setShowTagDialog(false)}
            />

            <Button
              label="Add Tags"
              onClick={handleAddTags}
            />

          </div>

        </div>

      </Dialog>
    </>
  );
}

export default MarkupChanger;